import BaseModel from '../base/BaseModel.model';
import Institution from './institution.Model';
export default class ProposedConsortium extends BaseModel {
    public proposedConsortiumId?: number;
    public institutionsId?: number;
    public isInternactionalCompany?:boolean;
    public institution?:  Institution | null;
    public porposalId?:number;
    public name?: string;
    public rnc?: string;
   

    public originalName : string = "";

    init(){
        this.isInternactionalCompany = false;
       this.proposedConsortiumId = 0;
       this.porposalId = 0;
       this.name = "";
       this.rnc = "";
       this.originalName ="";
    }

}